export const timeOptions=
  [
    { "key": "7:00", "title": "7:00" },
    { "key": "7:30", "title": "7:30" },
    { "key": "8:00", "title": "8:00" },
    { "key": "8:30", "title": "8:30" },
    { "key": "9:00", "title": "9:00" },
    { "key": "9:30", "title": "9:30" },
    { "key": "10:00", "title": "10:00" },
    { "key": "10:30", "title": "10:30" },
    { "key": "11:00", "title": "11:00" },
    { "key": "11:30", "title": "11:30" },
    { "key": "12:00", "title": "12:00" },
    { "key": "12:30", "title": "12:30" },
    { "key": "13:00", "title": "13:00" },
    { "key": "13:30", "title": "13:30" },
    { "key": "14:00", "title": "14:00" },
    { "key": "14:30", "title": "14:30" },
    { "key": "15:00", "title": "15:00" },
    { "key": "15:30", "title": "15:30" },
    { "key": "16:00", "title": "16:00" },
    { "key": "16:30", "title": "16:30" },
    { "key": "17:00", "title": "17:00" },
    { "key": "17:30", "title": "17:30" },
    { "key": "18:00", "title": "18:00" },
    { "key": "18:30", "title": "18:30" },
    { "key": "19:00", "title": "19:00" },
    { "key": "19:30", "title": "19:30" },
    { "key": "20:00", "title": "20:00" },
    { "key": "20:30", "title": "20:30" },
    { "key": "21:00", "title": "21:00" }
  ]